module.exports = __webpack_public_path__ + "img/3.4f661954.png";